var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMpaicn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1201 7.6665C13.1201 12.3332 7.12012 16.3332 7.12012 16.3332C7.12012 16.3332 1.12012 12.3332 1.12012 7.6665C1.12012 6.07521 1.75226 4.54908 2.87748 3.42386C4.0027 2.29864 5.52882 1.6665 7.12012 1.6665C8.71142 1.6665 10.2375 2.29864 11.3627 3.42386C12.488 4.54908 13.1201 6.07521 13.1201 7.6665Z",
    stroke: "#58595B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12012 9.6665C8.22469 9.6665 9.12012 8.77107 9.12012 7.6665C9.12012 6.56193 8.22469 5.6665 7.12012 5.6665C6.01555 5.6665 5.12012 6.56193 5.12012 7.6665C5.12012 8.77107 6.01555 9.6665 7.12012 9.6665Z",
    stroke: "#58595B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpaicn);
export default __webpack_public_path__ + "static/media/mpaicn.5f72c943e40eeb24ed607d908f3ed7a1.svg";
export { ForwardRef as ReactComponent };